import BButton from 'components/common/BButton';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

const PriceWidgetExtras: FunctionComponent = () => {
  const { t } = useTranslation('vehicle');
  return (
    <BButton
      className="mx-auto mt-4 block text-sm"
      variant="info"
      priority="contained"
      type="button"
    >
      {t('priceWidget.selectExtra')}
    </BButton>
  );
};

export default PriceWidgetExtras;
